import { createApp } from 'vue';
import VueCookies from 'vue3-cookies';
import VueGtm from '@gtm-support/vue-gtm';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import SetupService from '@/services/setup-service';
import App from './App.vue';
import AppInternal from './AppInternal.vue';
import router from './router';
//import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import LoadScript from 'vue-plugin-load-script';
import './themes/app.scss';

// import VueCompositionAPI from 'vue';
import VueScreen from 'vue-screen';
import store from '@/store';

const isInternal = window.location.href.includes('/internal');
const app = isInternal ? createApp(AppInternal) : createApp(App);

app.use(router);
app.use(store);

//app.use(BootstrapVue);
//app.use(IconsPlugin);
app.use(VueCookies);
app.use(LoadScript);

if (!isInternal) {
  const recaptchaKeys = {
    ci: {
      SZ: '6LcFEmAsAAAAAPrga_jEupPEpz8QZAtOlJa6LqCJ',
      ZGS: '6LerFSEsAAAAAHYhewuVed9JSTT4crDbrmOD3oNk',
    },
    stage: {
      SZ: '6Lf1yVksAAAAAGMm4p1orlkOr2kGqfSZSAiL9ouv',
      ZGS: '6LfcKV8sAAAAACLOhVgBLUzSAd1urUAn63cRCMNX',
    },
    prod: {
      SZ: '6LcLIEQsAAAAAAmyHKUtj8c6JsCXpjPjYWEXlkas',
      ZGS: '6Ldq_BcsAAAAAFGcwHE2VlLgknOKNP8w4Pm3miaz',
    },
  };
  const environment = window.environment || 'prod';
  const tenant =
    SetupService.getTenantId() ||
    new URLSearchParams(window.location.search).get('tenant');

  app.use(VueReCaptcha, {
    siteKey:
      tenant === 'sz'
        ? recaptchaKeys[environment].SZ
        : recaptchaKeys[environment].ZGS,
    loaderOptions: {
      autoHideBadge: false,
      useEnterprise: true,
    },
  });
}

app.use(VueGtm, {
  id: SetupService.getGtmId(),
  enabled: true,
  loadScript: true,
  vueRouter: router,
  debug: false,
});

app.use(VueScreen, 'bootstrap');

app.mount('#app');

// Was removed in Vue 3:
// app.config.productionTip = false;

// if (window.location.href.includes('/internal')) {
// new Vue({
//   router,
//   store,
//   render: h => h(AppInternal),
// }).$mount('#app');
// } else {
// new Vue({
//   router,
//   store,
//   render: h => h(App),
// }).$mount('#app');
// }
